var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentsCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1132.88 813.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1, .st2, .st3, .st4, .st5 {\n        fill: none;\n      }\n\n      .st6 {\n        fill: #2a556a;\n      }\n\n      .st7 {\n        fill: #e565c4;\n      }\n\n      .st8 {\n        fill: #ef5489;\n      }\n\n      .st9 {\n        fill: #d8e5e9;\n      }\n\n      .st10 {\n        fill: #c862a5;\n      }\n\n      .st11 {\n        fill: #697079;\n      }\n\n      .st1, .st2, .st3, .st4, .st5 {\n        stroke-linecap: round;\n      }\n\n      .st1, .st2, .st4 {\n        stroke-linejoin: round;\n      }\n\n      .st1, .st2, .st5 {\n        stroke: #f4f8fa;\n      }\n\n      .st1, .st3, .st4, .st5 {\n        stroke-width: 1.05px;\n      }\n\n      .st12 {\n        fill-rule: evenodd;\n      }\n\n      .st12, .st13, .st14 {\n        fill: #fff;\n      }\n\n      .st15 {\n        fill: #3b3f41;\n      }\n\n      .st16 {\n        fill: #a0d1e0;\n      }\n\n      .st17 {\n        fill: #774331;\n      }\n\n      .st18 {\n        fill: #f69159;\n      }\n\n      .st19 {\n        fill: #f6915a;\n      }\n\n      .st20 {\n        fill: #48c1bc;\n      }\n\n      .st21 {\n        fill: url(#radial-gradient);\n      }\n\n      .st22 {\n        fill: #49c0b9;\n      }\n\n      .st23 {\n        fill: #f05b61;\n      }\n\n      .st24 {\n        fill: #0e9c96;\n      }\n\n      .st25 {\n        fill: url(#linear-gradient);\n      }\n\n      .st26 {\n        fill: #103541;\n      }\n\n      .st27 {\n        fill: #103540;\n      }\n\n      .st2 {\n        stroke-width: 3.16px;\n      }\n\n      .st3 {\n        stroke: #2a556a;\n      }\n\n      .st3, .st5, .st14 {\n        stroke-miterlimit: 10;\n      }\n\n      .st28 {\n        fill: #b1e1f4;\n      }\n\n      .st29 {\n        isolation: isolate;\n      }\n\n      .st30 {\n        fill: #d7e4e8;\n      }\n\n      .st31, .st32 {\n        fill: #b26e4b;\n      }\n\n      .st33 {\n        fill: #1b566b;\n      }\n\n      .st32 {\n        mix-blend-mode: multiply;\n      }\n\n      .st4 {\n        stroke: #fc6;\n      }\n\n      .st34 {\n        fill: #1a586b;\n      }\n\n      .st35 {\n        fill: #dae3e6;\n      }\n\n      .st36 {\n        fill: #0e9d97;\n      }\n\n      .st37, .st38 {\n        fill: #48899b;\n      }\n\n      .st39 {\n        fill: #9aa3ad;\n      }\n\n      .st40 {\n        fill: #c962a5;\n      }\n\n      .st14 {\n        stroke: #000;\n        stroke-width: .53px;\n      }\n\n      .st41 {\n        fill: #f15961;\n      }\n\n      .st42 {\n        fill: #efb87b;\n      }\n\n      .st43 {\n        fill: #fc6;\n      }\n\n      .st44 {\n        fill: url(#radial-gradient1);\n      }\n\n      .st45 {\n        fill: url(#radial-gradient3);\n      }\n\n      .st46 {\n        fill: url(#radial-gradient2);\n      }\n\n      .st47 {\n        fill: url(#radial-gradient4);\n      }\n\n      .st48 {\n        fill: #3380a1;\n      }\n\n      .st49 {\n        fill: #f4f8fa;\n      }\n\n      .st50 {\n        fill: #0082a5;\n      }\n\n      .st51 {\n        fill: #47c2bb;\n      }\n\n      .st52 {\n        fill: #10bef0;\n      }\n\n      .st53 {\n        fill: #9770b0;\n      }\n\n      .st38 {\n        font-family: RalewayRoman-Medium, 'RalewayRoman Medium';\n        font-size: 15.13px;\n        font-variation-settings: ';\n        font-weight: 500;\n        letter-spacing: .02em;\n      }\n\n      .st54 {\n        fill: #422727;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 758.06,
    y1: 405.88,
    x2: 1116.69,
    y2: 405.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2e6f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 727.46,
    cy: 406.05,
    fx: 727.46,
    fy: 406.05,
    r: 666.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8af86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: 727.46,
    cy: 406.05,
    fx: 727.46,
    fy: 406.05,
    r: 666.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b497c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: 727.46,
    cy: 406.05,
    fx: 727.46,
    fy: 406.05,
    r: 666.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient3",
    cx: 727.46,
    cy: 406.05,
    fx: 727.46,
    fy: 406.05,
    r: 666.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fcff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient4",
    cx: 727.46,
    cy: 405.88,
    fx: 727.46,
    fy: 405.88,
    r: 667.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fb8b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st25",
    x: 758.06,
    y: 325.45,
    width: 358.63,
    height: 160.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M48.7,9.01v160.33s311.43,188.6,677.71,188.6v-32.49C360.13,325.45,48.7,9.01,48.7,9.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M48.7,802.75s311.43-316.44,677.71-316.44v-32.49c-366.28,0-677.71,188.6-677.71,188.6v160.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M48.7,310.69s311.43,75.9,677.71,75.9v-28.64c-366.28,0-677.71-188.6-677.71-188.6v141.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M48.7,642.42s311.43-188.6,677.71-188.6v-28.64c-366.28,0-677.71,75.9-677.71,75.9v141.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M48.7,501.08s311.43-75.9,677.71-75.9v-38.58c-366.28,0-677.71-75.9-677.71-75.9v190.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M535.69,304.82c-.11-6.26-4-12.1-10.23-14.4-8.11-2.98-17.11,1.18-20.09,9.29-.33.91-.57,1.82-.73,2.74-.11-.1-.23-.2-.37-.28-8.57-5.24-23.71-7.64-30.24-6.66-1.28.19-2.69.72-4.03,1.66-3.43,2.39-5.04,6.65-4.34,10.78l.13.76-.44,21.44c-.02,1.17.9,2.13,2.07,2.15.01,0,.03,0,.04,0,1.14,0,27.55,21.41,27.55,21.41,7.18-5.01,14.91-8.31,18.26-14.66l3.24-5.38v8.65c0,1.17.94,2.11,2.11,2.11s2.11-.94,2.11-2.11v-20.57c.39.44,5.2-2.14,5.78-2.4l.02-.02v29.85c0,1.17.94,2.11,2.11,2.11s2.11-.94,2.11-2.11v-34.61l.73-.83v26.47c0,1.17.94,2.11,2.11,2.11s2.11-.94,2.11-2.11v-35.34s0-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M498.55,327.38c11.89,2.51,19.34-4.14,19.34-4.14,0,0-2.82,14.02-20.86,11.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M500.79,320.24c11.89,2.51,18,.15,18,.15,0,0-1.79,5.71-18.63,4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M465.66,349.41l4.52-.02c2.4-.01,3.95-2.55,2.86-4.69l-5.2-10.27-5.09,10.32c-1.06,2.15.51,4.67,2.91,4.66Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M510.16,695.08h20.46s-.23,22.67-.23,22.67l.05,2.21c.87,25.69,22.9,32.13,26.83,33.07,1.27.31,2.25,1.24,2.38,2.55l.17,1.57h-44.34s-4.81-55.01-5.3-62.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M450.71,695.08c.25,6.88.49,13.75.75,20.63.19,4.9.63,9.72-.86,14.33-1.27,3.93-3.59,7.42-6.68,10.07-1.45,1.24-3.07,2.3-4.81,3.13,0,0-19.03,9.92-19.03,9.92-.72.35-1.23,1.03-1.37,1.83,0,.05-.07.93.13,2.16h53.45s-.91-54.84-.99-62.07h-20.59Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M452.09,720.47c-5.24-47.91-1.5-218.34-1.5-218.34l7.38-55.84h59.82c13.03,13.17,12.73,269.31,12.9,274.18h-22.78s-9.32-106.16-9.32-106.16l-9.15-101.39-8.85,100.42c-1.44,28.76-6.93,102-7.33,107.13h-21.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M536.02,400.87c-4.8-19.05-19.41-36.01-35.84-39.01l-1.08-15.16-17.07-9.44.34,24.6c-16.42,3-28.45,17.94-36.01,40.06l89.66-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M560.08,446.41c-5.6-40.79-25.11-68.74-44.38-79.01-4.46-2.38-10.38-4.59-15.51-5.53v-.03s-.03,0-.03,0l-16.88,20.57-1.05-20.57s-.03.04-.04.05c-13.61,2.52-28.96,9.25-38.08,24.1-.05,3.14,0,6.52,0,10.09v.02h0v149.94h85.83v-62.06c20.03,0,32.61-19.52,30.14-37.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M498.37,330.46c-1.39,3.78,1.63,7.57-.48,14.31-6.48,8.76-15.66,13.21-22.88,10.55-9.63-3.54-13.74-18.95-8.18-34.06,5.55-15.11,14.14-21.25,26.3-16.79,12.16,4.47,10.8,10.88,5.24,25.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M476.99,333.73c-.05-.02-.1-.05-.15-.09-.09-.08-2.32-1.88-2.56-4.01-.23-2.03,4.89-9.66,5.92-11.18.17-.25.5-.31.75-.14.25.17.31.5.14.75-2.46,3.62-5.87,9.25-5.73,10.45.16,1.4,1.61,2.84,2.16,3.28.23.19.27.53.08.76-.15.19-.4.25-.61.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M456.8,316.3c-1.08,5.7,2.68,11.22,8.38,12.3,4.97.94,9.81-1.8,11.68-6.3l4.15.79c.09,4.87,3.59,9.19,8.56,10.14,5.7,1.08,11.22-2.68,12.3-8.38,1.08-5.7-2.68-11.22-8.38-12.3-5.7-1.08-11.22,2.68-12.3,8.38-.03.18-.05.36-.07.54l-3.77-.71c.04-.18.09-.35.13-.53,1.08-5.7-2.68-11.22-8.38-12.3-5.7-1.08-11.22,2.68-12.3,8.38ZM482.78,321.22c.91-4.82,5.58-8.01,10.41-7.09,4.82.91,8.01,5.58,7.09,10.41-.91,4.82-5.58,8.01-10.41,7.09s-8.01-5.58-7.09-10.41ZM458.39,316.6c.91-4.82,5.58-8.01,10.41-7.09s8.01,5.58,7.09,10.41c-.91,4.82-5.58,8.01-10.41,7.09s-8.01-5.58-7.09-10.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M379.56,383.56c-.98-5.16-.89-11.46-.59-16.21.32-5.1,2.08-10,4.96-14.22.02-.03.04-.05.05-.08.96-1.41,2.14-2.86,4.14-2.68,1.35.12,2.51,1.01,3.19,2.18.92,1.59-.28,6.09,5.48,9.85,5.1,3.33,7.45,10.03,9.55,16.24l-26.79,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M406.35,378.64c-.47-.58-26.79,4.92-26.79,4.92,1.66,10.79,9.9,29.71,15.8,40.95,14.48,27.6,46.25,40.17,64.71,11.69.2-.31-2.14-48.4-10.55-57.49,0,0-7.38,11.08-22.68,22.68l-20.49-22.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M496.29,355.71h4.52c2.4.02,3.97-2.5,2.9-4.65l-5.12-10.31-5.18,10.28c-1.08,2.14.48,4.68,2.88,4.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M559.64,755.58c-.14-1.31-1.11-2.24-2.38-2.55-2.56-.61-12.78-3.56-19.85-12.63-7.57,1.36-11.34,5.96-13.21,10.61-4.22-.51-7.36-2.05-9.59-3.66.51,5.88.86,9.8.86,9.8h44.34l-.17-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M472.14,748.24c-6.14,2.3-13.03,1.55-18.73-1.88-4.44-2.66-8.93-3.57-12.8-3.92-.49.28-.98.55-1.5.8l-19.03,9.92c-.72.35-1.23,1.03-1.37,1.83,0,.05-.07.93.13,2.16h53.45s-.06-3.53-.15-8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M507.7,442.79l-2.74-4.6c-2.49-3.35-6.45-3.07-7.58,1.16-6.04-2.78-12.73-4.45-20.12-.11-2.98,1.75-3.96,5.67-2.16,8.63,6.49,10.68,15.19,14.26,15.19,14.26,0,0,16.79-.19,22.34-16.08-.01,0-.02,0-.03,0-2.04-.24-3.84-1.48-4.89-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M507.71,388.56c-5.94,0-10.77,4.83-10.77,10.77,0,5.94,4.83,10.77,10.77,10.77,5.94,0,10.77-4.83,10.77-10.77,0-5.94-4.83-10.77-10.77-10.77ZM507.71,389.63c4.64,0,8.53,3.32,9.46,7.66h-5.25c-.26,0-.49.21-.54.47l-1.07,5.95-2.51-11.16c-.05-.25-.27-.43-.52-.44-.26,0-.48.16-.55.41l-2.36,8.9-.98-3.7c-.06-.24-.28-.43-.53-.43h-4.59c.93-4.33,4.81-7.66,9.46-7.66ZM507.71,409c-5.33,0-9.67-4.32-9.67-9.65,0-.31.02-.64.04-.89h4.34s1.41,5.27,1.41,5.27c.06.24.28.4.53.4s.47-.18.53-.42l2.28-8.63,2.68,11.42c.05.26.28.43.54.43s.49-.17.54-.43l1.43-8.04h4.96c.03.25.04.59.04.89,0,5.33-4.34,9.65-9.67,9.65Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M505.47,249.74l-11.29-11.29-7.45,7.45,11.29,11.29c2.06,2.06,5.39,2.06,7.45,0,2.06-2.06,2.06-5.39,0-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M503.55,226.17l-32.63-32.63c-8-8-21.1-8-29.1,0-8,8-8,21.1,0,29.1l32.63,32.63c3.65,3.65,9.62,3.65,13.27,0l15.82-15.82c3.65-3.65,3.65-9.62,0-13.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M461.22,201.05c-3.28-3.28-8.61-3.28-11.89,0-3.28,3.28-3.28,8.61,0,11.89,3.28,3.28,8.61,3.28,11.89,0,3.28-3.28,3.28-8.61,0-11.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st49",
    x: 468.82,
    y: 217.37,
    width: 21.09,
    height: 27.43,
    rx: 7.58,
    ry: 7.58,
    transform: "translate(-23.01 406.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st38",
    transform: "translate(468.69 224.93) rotate(45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "135")), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M471.01,211.31c-.57-.57-1.5-.57-2.07,0l-9.35,9.35c-.57.57-.57,1.5,0,2.07.29.29.66.43,1.04.43s.75-.14,1.04-.43l9.35-9.35c.57-.57.57-1.5,0-2.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M80.86,302.28c0-22.7,18.47-41.17,41.17-41.17,22.7,0,41.16,18.47,41.16,41.17s-18.47,41.17-41.16,41.17-41.17-18.47-41.17-41.17ZM90.48,302.28c0,17.39,14.15,31.54,31.54,31.54,17.39,0,31.54-14.15,31.54-31.54,0-17.39-14.15-31.54-31.54-31.54-17.39,0-31.54,14.15-31.54,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M122.01,261.11v9.63c-17.38,0-31.52,14.15-31.52,31.54,0,17.39,14.15,31.54,31.54,31.54,9.29,0,17.66-4.04,23.43-10.45l7.16,6.42c-7.54,8.38-18.46,13.66-30.6,13.66-22.7,0-41.17-18.47-41.17-41.17,0-22.69,18.46-41.16,41.15-41.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M108.63,309.28s0,0,0,.01c.88-.26,9.58-2.23,9.57-2.29-.25-1.17-.48-2.24-.73-3.59-.33-1.81-.67-5.07,0-7.91.85-3.55.21-7.24-1.31-10.56-1.04-2.25-3.17-4.87-5.75-5.35-2.88-.54-4.87,1.89-5.84,4.32-1.38,3.42-1.46,7.25-.83,10.88.63,3.63,1.95,7.1,3.32,10.52.52,1.31,1.18,2.62,1.56,3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M118.49,308.37l-9.42,2.24c.46,1.39.91,2.73,1.34,3.94,1.04,2.93,3.47,4.17,5.5,3.8,2.03-.37,3.93-2.91,3.47-5.44-.35-1.93-.64-3.34-.89-4.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M136.27,320.84s0,0,0,.01c-.88-.26-9.58-2.23-9.57-2.29.25-1.17.48-2.24.73-3.59.33-1.81.67-5.07,0-7.91-.85-3.55-.21-7.24,1.31-10.56,1.04-2.25,3.17-4.87,5.75-5.35,2.88-.54,4.87,1.89,5.84,4.32,1.38,3.42,1.46,7.25.83,10.88-.63,3.63-1.95,7.1-3.32,10.52-.52,1.31-1.18,2.62-1.56,3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M126.41,319.94l9.42,2.24c-.46,1.39-.91,2.73-1.34,3.94-1.04,2.93-3.47,4.17-5.5,3.8-2.03-.37-3.93-2.91-3.47-5.44.35-1.93.64-3.34.89-4.54Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 385.82,
    y: 426.15,
    width: 27.8,
    height: 27.66,
    rx: 1.62,
    ry: 1.62,
    transform: "translate(839.7 40.26) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 176.67,
    y: 195.73,
    width: 30.74,
    height: 36.84,
    rx: 1.62,
    ry: 1.62,
    transform: "translate(406.19 22.11) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 309.27,
    y: 477.5,
    width: 17.15,
    height: 22.6,
    rx: 1.62,
    ry: 1.62,
    transform: "translate(806.65 170.96) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 344.83,
    y: 192.59,
    width: 15.32,
    height: 15.18,
    rx: 1.85,
    ry: 1.85,
    transform: "translate(552.68 -152.31) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 80.79,
    y: 381.94,
    width: 23.79,
    height: 23.57,
    rx: 1.85,
    ry: 1.85,
    transform: "translate(486.41 301.04) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 648.19,
    y: 394.19,
    width: 18.22,
    height: 20.7,
    rx: 1.75,
    ry: 1.75,
    transform: "translate(1061.84 -252.76) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 284.05,
    y: 455.64,
    width: 33.26,
    height: 33.09,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(772.87 171.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 427.12,
    y: 332.34,
    width: 17.5,
    height: 20.98,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(778.7 -93.05) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 591.63,
    y: 255.91,
    width: 17.25,
    height: 17.1,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(864.71 -335.79) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 397.54,
    y: 583.43,
    width: 17.25,
    height: 17.1,
    rx: 1.63,
    ry: 1.63,
    transform: "translate(998.14 185.81) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 163.3,
    y: 249.07,
    width: 13.68,
    height: 13.56,
    rx: 1.86,
    ry: 1.86,
    transform: "translate(425.99 85.71) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 162.96,
    y: 115.43,
    width: 8.77,
    height: 8.69,
    rx: 1.86,
    ry: 1.86,
    transform: "translate(287.11 -47.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 235.18,
    y: 225.09,
    width: 16.27,
    height: 18.49,
    rx: 1.76,
    ry: 1.76,
    transform: "translate(477.65 -8.98) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 135.32,
    y: 560.59,
    width: 12.42,
    height: 14.11,
    rx: 1.76,
    ry: 1.76,
    transform: "translate(709.18 426.12) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 181.37,
    cy: 479.64,
    r: 5.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M191.05,537.18c.18-.51.05-1.06-.31-1.46-3-3.3-5.24-11.09-.51-24.68,5.04-14.49.35-23.5-10.31-27.21-10.66-3.71-19.93.45-24.97,14.94-4.72,13.58-11.31,18.31-15.72,19.03-.53.09-.97.44-1.15.95l-.02.05c-.26.75.14,1.57.88,1.83l50.26,17.48c.75.26,1.57-.14,1.83-.88l.02-.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st43",
    cx: 174.83,
    cy: 533.68,
    r: 7.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181.58,510.62h0c-.34-.7-1.18-.99-1.88-.65l-4.12,1.99-1.69-3.49c2.86.18,5.04-1.74,5.87-4.11.51-1.48.49-3.04-.05-4.4-.63-1.56-1.88-2.71-3.61-3.31l-6.73-2.34c-.74-.26-1.54.13-1.79.87l-5.65,16.25c-.26.74.13,1.54.87,1.79h0c.74.26,1.54-.13,1.79-.87l2.13-6.13,3.55,1.24,2.77,5.73-4.12,1.99c-.7.34-.99,1.18-.65,1.88h0c.34.7,1.18.99,1.88.65l4.12-1.99,1.99,4.12c.34.7,1.18.99,1.88.65h0c.7-.34.99-1.18.65-1.88l-1.99-4.12,4.12-1.99c.7-.34.99-1.18.65-1.88ZM169.77,497.44l5.39,1.88c2.37.82,2.32,2.98,1.93,4.12-.28.81-.83,1.5-1.49,1.87-.74.42-1.61.47-2.57.13l-5.39-1.88,2.13-6.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M139.23,517.81c-.53.09-.97.44-1.15.95l-.02.05c-.26.75.14,1.57.88,1.83l50.26,17.48c.75.26,1.57-.14,1.83-.88l.02-.05c.18-.51.05-1.06-.31-1.46-1.34-1.47-2.53-3.85-3.01-7.22l-41.66-14.49c-2.48,2.35-4.88,3.47-6.84,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M187.89,551.7c-.37,0-.72-.21-.89-.56-.23-.49-.02-1.08.47-1.31,9.66-4.56,13.54-16.7,8.64-27.07-.23-.49-.02-1.08.47-1.31.49-.23,1.08-.02,1.31.47,5.36,11.34,1.06,24.66-9.58,29.68-.14.06-.28.09-.42.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M131.72,533.1c-.37,0-.72-.21-.89-.56-2.59-5.48-3.03-11.58-1.23-17.18,1.8-5.62,5.64-10.06,10.81-12.5.49-.23,1.08-.02,1.31.47.23.49.02,1.08-.47,1.31-4.67,2.2-8.14,6.23-9.78,11.32-1.64,5.12-1.24,10.71,1.13,15.74.23.49.02,1.08-.47,1.31-.14.06-.28.09-.42.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M192.79,559.73c-.4,0-.79-.23-.97-.61-.25-.54-.02-1.17.51-1.43,6.54-3.09,11.4-8.72,13.69-15.86,2.3-7.16,1.74-14.98-1.59-22.02-.25-.54-.02-1.17.51-1.43.54-.25,1.17-.02,1.43.51,3.56,7.53,4.15,15.91,1.69,23.59-2.48,7.71-7.74,13.8-14.82,17.14-.15.07-.3.1-.46.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M123.32,536.19c-.4,0-.79-.23-.97-.61-3.56-7.53-4.15-15.91-1.69-23.59,2.48-7.71,7.74-13.8,14.82-17.14.54-.25,1.17-.02,1.43.51.25.54.02,1.17-.51,1.43-6.54,3.09-11.4,8.72-13.69,15.86-2.3,7.16-1.74,14.98,1.59,22.02.25.54.02,1.17-.51,1.43-.15.07-.3.1-.46.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st35",
    x: 234.89,
    y: 125.49,
    width: 76.28,
    height: 52.82,
    rx: 5.39,
    ry: 5.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M311.16,145.89v-.75h-10.4v-10.72h-.75v10.72h-10.15v-10.72h-.75v10.72h-10.15v-10.72h-.75v10.72h-10.15v-10.72h-.75v10.72h-10.15v-10.72h-.75v10.72h-10.15v-10.72h-.75v10.72h-10.65s0,.75,0,.75h10.65v10.15h-10.65v.75h10.65v10.15h-10.65v.75h10.65v10.62h.75v-10.62h10.15v10.62h.75v-10.62h10.15v10.62h.75v-10.62h10.15v10.62h.75v-10.62h10.15v10.62h.75v-10.62h10.15v10.62h.75v-10.62h10.4v-.75h-10.4v-10.15h10.4v-.75h-10.4v-10.15h10.4ZM289.11,145.89v10.15h-10.15v-10.15h10.15ZM278.21,145.89v10.15h-10.15v-10.15h10.15ZM267.31,145.89v10.15h-10.15v-10.15h10.15ZM246.25,145.89h10.15v10.15h-10.15v-10.15ZM246.25,166.94v-10.15h10.15v10.15h-10.15ZM257.15,166.94v-10.15h10.15v10.15h-10.15ZM268.06,166.94v-10.15h10.15v10.15h-10.15ZM278.96,166.94v-10.15h10.15v10.15h-10.15ZM300.01,166.94h-10.15v-10.15h10.15v10.15ZM300.01,156.04h-10.15v-10.15h10.15v10.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M307.66,125.49h-69.26c-1.94,0-3.51,1.57-3.51,3.51v5.7h76.28v-5.7c0-1.94-1.57-3.51-3.51-3.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st52",
    cx: 294.75,
    cy: 163.09,
    r: 8.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M300.85,165.18h-4.01v4.01h-4.19v-4.01h-4.01v-4.19h4.01v-4.01h4.19v4.01h4.01v4.19Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M368.43,277.17l-12.15-20.63c-8.83-15.3-29.98-15.79-45.27-6.96h0c-.08.05-.16.1-.24.15-.09.05-.17.09-.26.14h0c-15.3,8.83-20.54,28.39-11.71,43.69l12.15,20.63c8.83,15.3,28.39,20.54,43.69,11.71.08-.05.16-.1.24-.15.09-.05.17-.09.26-.14h0c15.3-8.83,22.12-33.14,13.29-48.44ZM325.23,304.14l-12.15-20.63c-5.15-8.92-5.51-15.59-1.88-24.44,11.76-4.29,19.35,1,25.54,11.73l12.15,20.63c5.15,8.92,3.49,20.73-2.86,27.08-11.57.55-14.6-3.64-20.8-14.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M372.49,291.16l-16.34,11.48c-3.55,2.49-8.47,1.44-10.69-2.29l-19.33-32.48c-1.99-3.35-1.07-7.67,2.12-9.91l16.34-11.48c3.55-2.49,8.47-1.44,10.69,2.29l19.33,32.48c1.99,3.35,1.07,7.67-2.12,9.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M369.93,284.23l-13.96,9.81c-2.03,1.43-4.85.82-6.12-1.31l-15.42-25.91c-1.14-1.92-.61-4.39,1.21-5.67l13.96-9.81c2.03-1.43,4.85-.82,6.12,1.31l15.42,25.91c1.14,1.92.61,4.39-1.21,5.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M612.2,370.7s32.79-19.62,32.8-38.07c0-9.42-7.67-17.17-17.15-17.17-6.94,0-12.91,4.11-15.62,10.03-2.7-5.92-8.67-10.05-15.61-10.05-9.48,0-17.17,7.73-17.17,17.15-.01,18.45,32.76,38.11,32.76,38.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M661.64,346.4h-20.99s-6.04-6.4-6.04-6.4c-.23-.24-.54-.37-.87-.37,0,0,0,0,0,0-.33,0-.64.13-.87.37l-6.05,6.39h-5.89c-.42,0-.82.22-1.03.59l-4.84,8.23-5.74-27.48c-.1-.5-.49-.92-.99-.99-.63-.09-1.2.3-1.35.89l-5.69,22.59-4.92-8.73c-.18-.31-.48-.53-.83-.59-.35-.06-.71.04-.98.27l-6.05,5.19-26.42-.02c-.67,0-1.21.55-1.19,1.22h0c.01.65.54,1.17,1.19,1.17l26.86.02c.29,0,.56-.1.78-.29l5.28-4.53,5.68,10.06c.24.43.72.66,1.2.6.48-.06.88-.42,1-.89l5.15-20.45,5.31,25.41c.1.49.46.9.95.99.08.02.15.02.23.02.42,0,.81-.22,1.03-.59l6.06-10.31h5.72c.33,0,.64-.13.87-.37l5.54-5.85,5.53,5.85c.23.24.54.37.87.37h21.5c.67.01,1.21-.54,1.19-1.21h0c-.01-.65-.54-1.17-1.19-1.17Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M837.92,591.77l-145.68,44.17c-15.25,4.62-30.64-6.79-30.64-22.73V205.32c0-16.06,15.6-27.49,30.91-22.65l145.68,46.07c9.88,3.12,16.59,12.29,16.59,22.65v317.66c0,10.46-6.85,19.69-16.86,22.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "682.91 235.68 682.91 575.31 852.16 537.22 852.16 275.41 682.91 235.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "690.68 563.41 844.36 531.45 844.36 425.49 690.68 431.29 690.68 563.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M829.73,444.05v28.78s5.55,2.23,5.55,2.23c.69.28.55,1.3-.19,1.38l-102.15,11.68c-3.02.34-5.66-2.01-5.66-5.05v-34.3c0-2.71,2.12-4.94,4.82-5.08l92.29-4.72c2.91-.15,5.34,2.17,5.34,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M705.32,531.67v-25.26c0-3.19,2.38-5.88,5.54-6.27l89.82-11.08c3.77-.46,7.09,2.47,7.09,6.27v17.31c0,3.04-2.16,5.65-5.15,6.21l-102.01,19.21c-.96.18-1.53-1.02-.8-1.66l5.5-4.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "690.68 420.72 844.36 418.5 844.36 353.52 690.68 335.1 690.68 420.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "774.62 337.47 844.33 346.38 844.33 283.06 774.62 267.79 774.62 337.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M838.39,319.38l-57.41-8.22,57.41,8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M838.46,315.27l-57.47-8.68,57.47,8.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M838.39,323.95l-57.41-8.22,57.41,8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M838.39,327.74l-57.41-7.44,57.41,7.44Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 824.51,
    y1: 330.13,
    x2: 780.98,
    y2: 324.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M812.3,303.43l-31.31-5.48,31.31,5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M827.95,300.2l-46.97-8.22,46.97,8.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "690.68 326.86 768.91 336.88 768.91 266.21 690.68 249.86 690.68 326.86"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M730.86,326.27c-14.7-1.98-26.66-17.69-26.66-35.02s11.96-29.81,26.66-27.83c14.7,1.98,26.66,17.69,26.66,35.02s-11.96,29.81-26.66,27.83ZM730.86,265.39c-13.78-1.86-25,9.84-25,26.09s11.21,30.97,25,32.83c13.78,1.86,25-9.84,25-26.09s-11.21-30.97-25-32.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M738.76,317.45c-.38-.05-.72-.4-.81-.86l-7.44-36.84-6.21,26.65c-.1.41-.42.67-.79.62h-.01c-.37-.05-.69-.38-.8-.81l-3.87-15.8-13.58-1.83c-.46-.06-.83-.55-.83-1.09s.37-.93.83-.87l14.2,1.92c.37.05.69.38.8.81l3.21,13.08,6.29-26.99c.1-.42.43-.67.81-.62h0c.38.06.71.41.8.86l7.21,35.71,2.49-19.1c.06-.47.41-.78.82-.72l14.61,1.97c.46.06.83.55.83,1.09s-.37.93-.83.87l-13.9-1.87-3.01,23.11c-.06.46-.39.76-.79.73-.01,0-.03,0-.04,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M735.08,453.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M735.08,461.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M735.08,469.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M735.08,477.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M735.08,485.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 823.77,
    y1: 448.16,
    x2: 735.08,
    y2: 453.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 823.77,
    y1: 455.55,
    x2: 735.08,
    y2: 462.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 823.77,
    y1: 462.93,
    x2: 735.08,
    y2: 470.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 765.29,
    y1: 476.12,
    x2: 735.08,
    y2: 479.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 802.5,
    y1: 496.69,
    x2: 713.82,
    y2: 509.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 802.5,
    y1: 504.6,
    x2: 713.82,
    y2: 518.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 780.06,
    y1: 515.67,
    x2: 713.82,
    y2: 526.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st33",
    cx: 778.82,
    cy: 235.35,
    rx: 4.6,
    ry: 6.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st33",
    cx: 790.22,
    cy: 238.53,
    rx: 2.86,
    ry: 4.17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M774.73,367.54l4.92,9.05-13.12,10.98-4.92-9.05c-2.8-5.15-2.13-11.78,1.49-14.82h0c3.62-3.03,8.83-1.31,11.63,3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M784.86,386.19c2.8,5.15,2.13,11.78-1.49,14.82h0c-3.62,3.03-8.83,1.31-11.63-3.84l-5.22-9.6,13.12-10.98,5.22,9.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M758.74,401.01c-2.83-3.95-3.33-9.5-1.46-13.38l11.66,16.31c-3.14,2.11-7.38,1.02-10.2-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M770.18,387.34c2.83,3.95,3.33,9.5,1.46,13.38l-11.66-16.31c3.14-2.11,7.38-1.02,10.2,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M758.46,385.78c.46-.55.97-1.01,1.51-1.37l11.66,16.31c-.32.67-.71,1.29-1.18,1.84-.46.55-.97,1.01-1.51,1.37l-11.66-16.31c.32-.67.71-1.29,1.18-1.84Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M819.95,358.68c-1.94,4.03-5.58,7.26-10.2,8.51-1.69.46-3.4.61-5.05.51v10.4c0,9.83,4.05,19.58,10.62,25.58l4.63,4.22,4.63-2.7c6.57-3.84,10.62-12.26,10.62-22.09v-10.4c-1.65-.44-3.35-1.15-5.05-2.16-4.62-2.77-8.26-7.19-10.2-11.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M813.4,386.93l3.64.6v4.72c0,.61.38,1.16.85,1.24l4.12.68c.47.08.85-.35.85-.96v-4.72s3.64.6,3.64.6c.47.08.85-.35.85-.96v-5.34c0-.61-.38-1.16-.85-1.24l-3.64-.6v-4.72c0-.61-.38-1.16-.85-1.24l-4.12-.68c-.47-.08-.85.35-.85.96v4.72s-3.64-.6-3.64-.6c-.47-.08-.85.35-.85.96v5.34c0,.61.38,1.16.85,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M819.95,364.55c2.42,3.78,5.69,7,9.34,9.19,1.05.63,2.12,1.16,3.19,1.6v7.32c0,8.55-3.55,15.93-9.26,19.26l-3.27,1.91-3.27-2.98c-5.71-5.21-9.26-13.76-9.26-22.31v-7.32c1.08-.09,2.15-.27,3.19-.55,3.65-.99,6.92-3.14,9.34-6.12M819.95,362.46c-2.34,3.35-5.75,5.79-9.68,6.86-1.28.35-2.59.54-3.91.57v8.48c0,9.03,3.75,18.07,9.79,23.58l3.8,3.46,3.8-2.22c6.04-3.52,9.79-11.33,9.79-20.36v-8.48c-1.32-.47-2.63-1.09-3.91-1.86-3.93-2.35-7.34-5.91-9.68-10.03h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M745.4,381.74c0,16.66-10.43,28.88-23.29,27.31-12.86-1.57-23.29-16.35-23.29-33.01s10.43-28.88,23.29-27.31c12.86,1.57,23.29,16.35,23.29,33.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M729.7,363.16c-1.47-2.75-4.04-4.55-7.17-4.93-1.7-.21-3.45.04-4.87.74-3.53,1.72-4.48,5.2-4.87,8.08-.16,1.21.04,2.47.56,3.4.48.88,1.11,1.42,1.94,1.62,2.02.56,2.97-1.28,3.53-2.85.2-.59.99-2.55,2.22-3.06.16-.03.52-.09.99-.03.44.05,1.98.35,2.7,1.72,1.27,2.47.44,5.49-1.07,6.95-2.5,2.36-3.69,4.84-3.88,8.1-.04,1.12.2,2.23.75,3.02.48.73,1.15,1.17,1.98,1.27,2.1.26,3.01-2.45,3.29-3.65.16-.75.91-1.79,1.74-3.02.71-.99,1.51-2.13,2.26-3.42,1.82-3.16,2.73-8.49-.08-13.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M722.69,389.87c-.28-.09-.56-.17-.83-.21-2.3-.28-3.33,2.57-3.33,4.67,0,2.31,1.43,5,3.73,5.28,1.7.21,3.13-1.21,3.49-3.42.24-1.41.12-2.71-.36-3.79-.52-1.14-1.43-2.02-2.69-2.54Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M971.35,376.19c-5.54.78-12.08,10.45-31.64-1.05-8.97-5.27-17.4,1.58-12.13-27.42,1.17-6.45,12.66-31.12,6.33-41.14-8.95-14.17,12.66-22.15,37.45-5.27,17.89,12.18,16.88,31.64,17.93,68.56.46,16-17.1,6.21-17.93,6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M923.29,699.71l-9.28-3.21-.88-188.55,7.21-64.87h58.45c12.74,12.87,12.92,97.57,9.46,171.51,2.62,29.77,1.29,77.14,1.46,81.9l-8.85,3.28-9.67-3.28-20.08-178-13.5,98.13c-1.41,28.1-3.08,74.86-3.47,79.87l-10.84,3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M1000.36,394.46c-4.69-18.62-22.72-30.94-38.76-33.87l-2.91-29.76-13.44,14.95-1.05,14.81c-16.05,2.93-29.48,11.82-36.86,33.45l93.03.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M898.04,417.32c0-3.68-1.25-7.15-3.46-10.24,5.14-2.46,9.38-7.6,13.48-16.41,4.11-10.22,9.99-17.3,16.66-22.1-.03.04-.05.08-.08.12.9-.72,1.94-1.42,3.17-2.16,5.98,4.1,14.56,6.67,24.1,6.67,9.95,0,18.86-2.8,24.85-7.21,10.86,5.84,19.92,14.04,24.14,28.46,4.21,14.43,19.51,50.82,0,72.44-1.16,1.29-11.77-9.02-13-7.86,1.18,15.03,2.45,37.58,2.45,65.35h-77.53s-2.14-34.19,4.75-69.49c1.57-8.03,1.84-16.25.72-24.36-.01-.09-.02-.17-.04-.26-.05.08-.11.15-.16.23-1.29,1.75-8.97,5.8-23.05,5.8-.13,0-.26,0-.39,0-3.03,0-5.97-.41-8.78-1.14,7.44-4.26,12.18-10.67,12.18-17.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M960.62,303.39c-11-5.11-18.97-.51-26.72,10.35-1.06,1.31-6.37,8.04-6.31,9.92.06,1.88,1.86,3.72,3.6,4.59-3.26,11.08-1.56,18.53,5.12,21.63,9.09,4.22,21.84-.83,29.63-17.61,6.26-13.5,6.5-23.39-5.31-28.87Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M923.33,720.75l-10.44-2.1,1.13-22.15h20.12c-.55,7.06-1.12,14.72-1.66,22.15l-9.15,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M982.41,720.67l-8.67-2.02-2.55-22.15h18.53c.25,6.9.45,14.61.62,22.15l-7.92,2.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M945.67,753.99h45.22c0,.39,0,.75.01,1.05,0,0,0,0,0,0,0,.23,0,2.11,0,2.11h-45.78v-1.9c0-.14.02-.28.06-.41.11-.31.27-.6.48-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M872.35,755.04c.1-.39.29-.75.54-1.05h57.07c-.03.38-.05.74-.07,1.05l-.1,2.11h-57.5c-.09-1.21.05-2.06.06-2.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M845.89,382.36c4.65-4.19,14.49-4.8,19.56.82,3.06,3.4,4.1,10.67,4.82,14.59,1.94,4.48,10.29,11.12,15.93,11.12.02,0,.05,0,.07,0,3.04-.04,5.78-.6,8.3-1.8,2.21,3.09,3.46,6.56,3.46,10.24,0,7.18-4.74,13.59-12.18,17.85-11.84-3.09-21.52-12.09-26.97-22.04-.96-1.22-2.6-4.36-5.39-11.06-1.76-.86-3.44-2.09-4.88-3.7-5.07-5.62-7.37-11.82-2.72-16.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M943.66,360.63s-13.83,22.04-2.83,23.02c11,.98,20.76-23.06,20.76-23.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M941.68,296.28c8.92-.91,15.4,1.72,19.8,4.84,28.97-6.03,26.98,39.97,20.94,56.08-6.83,18.21-26.37,20.57-33.23,42.19-6.86-31.12,10.55-60.65,10.55-60.65,0,0-7.79-19.33-6.6-29.94-1.31,4.44-1.42,10.11.27,14.12-5.57-2.83-7.91-6.33-8.44-12.66-1.05,2.11-.54,4.94,0,6.86-6.5-4.74-7.72-13.98-3.3-20.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M934.62,472.26c-1.04-6.17,3.73-14.8,11.19-16.06,4.51-.76,11.2,2.27,14.89,3.76,4.82.77,14.9-2.71,17.93-7.47.01-.02.03-.04.04-.06,1.6-2.59,2.6-5.2,2.93-7.97,3.79-.21,7.4.6,10.5,2.58,6.05,3.85,8.92,11.29,8.52,19.86-8.96,8.33-21.75,11.67-33.08,10.92-1.55.16-5.07-.15-12.22-1.39-1.67,1.03-3.61,1.77-5.74,2.13-7.47,1.26-13.93-.12-14.97-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M954.54,476.87c.98.86,2.13,1.36,3.36,1.36,3.64,0,6.59-4.31,6.59-9.62s-2.66-9.17-6.04-9.58c-1.31-.53-2.78-1.11-4.31-1.61,1.15-.68,2.42-1.06,3.76-1.06,5.09,0,9.23,5.5,9.23,12.25,0,6.76-4.14,12.25-9.23,12.25-2.26,0-4.34-1.09-5.94-2.89.91-.3,1.78-.67,2.59-1.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M918.34,737.72l.44-2.07c.61-2.84-1.38-5.58-4.26-5.89l-3.13-.33c.88-2.52,1.35-5.21,1.36-7.97h0s0-.14,0-.14c0-.17,0-.34,0-.51l.03-.06.11-2.1h19.59c-.56,7.6-1.08,14.95-1.52,21.16-6.24,3.19-12.61-2.09-12.61-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M872.89,753.99c.26-.31.58-.56.96-.73l24.72-9.69c6.13-2.82,10.68-7.99,12.82-14.13l3.13.33c2.89.31,4.87,3.05,4.26,5.89l-.44,2.07s6.38,5.28,12.61,2.09c-.43,6.13-.78,11.15-.99,14.18h-57.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M986.53,737.19l.32-2.07c.43-2.84-.98-5.58-3.05-5.89l-10.2-.21c.33-2.65.4-5.43.33-8.21l.05-.14-.23-2.02h16.58c.16,7.17.29,14.94.38,21.37-2.41-.78-4.18-2.82-4.18-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M945.67,753.99h0s-.02.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M945.68,753.99c.07-.07.52-.53.95-.73l17.33-8.94c6.31-2.91,8.81-8.68,9.63-15.29l10.2.21c2.06.31,3.48,3.05,3.05,5.89l-.32,2.07s1.77,2.05,4.18,2.82c.12,8.19.19,14.19.19,13.97h-45.22Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M214.52,389.93l-4.8-27.43,21.81-5.08,9,31.82c20.9,2.91,25.26,10.01,28.73,24.91l-72.62,11.4c-3.47-14.91-4.41-27.71,17.88-35.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M207.43,319.79c10.87-6.8,19.83-3.03,29.38,7.33,1.29,1.24,7.73,7.59,7.92,9.57.19,1.98-1.46,4.14-3.17,5.29,4.87,11.19,6.99,17.12-2.05,23.12-8.82,5.86-23.48,2.24-33.86-14.34-8.34-13.33-9.89-23.67,1.77-30.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M243.47,637.93l11.34-74.95,15.92,67.31,1.07,25.84h28.93l1.52-26.56s.77-69.9-3.57-94.22c-10.2-57.1-41.99-30.95-43.87-27.33-1.89-3.62-48.08,38.02-48.08,38.02l.16,90.44-2.65,19.64h33.15l6.08-18.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M206.73,546.05c-7.98-96.92-34.86-145.37,7.57-156.25,50.37-12.92,75.42,25.32,84.38,145.56-47.99,13.18-91.96,10.69-91.96,10.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M215.29,416.81c-10.87,1.77-17.93,14.15-15.75,27.6,2.18,13.45,12.81,22.96,23.67,21.2,10.87-1.77,17.94-14.15,15.75-27.6-2.18-13.45-12.8-22.96-23.67-21.2ZM215.68,419.23c8.5-1.38,16.84,5,20.13,14.54l-9.61,1.56c-.48.08-.83.61-.82,1.22l.23,13.79-8.71-24.55c-.18-.55-.65-.9-1.12-.84-.48.06-.82.51-.85,1.09l-1.04,20.87-3.16-8.09c-.21-.53-.67-.88-1.13-.81l-8.41,1.37c.1-10.1,6-18.78,14.49-20.16ZM222.81,463.11c-9.76,1.58-19.29-6.92-21.25-18.99-.11-.69-.21-1.46-.25-2.03l7.94-1.29,4.51,11.51c.21.53.67.83,1.12.75.46-.07.79-.54.82-1.11l1-20.23,9.11,25.08c.19.57.67.9,1.15.82.49-.08.84-.53.83-1.13l-.34-18.65,9.08-1.48c.14.56.29,1.31.41,2.01,1.96,12.08-4.39,23.16-14.15,24.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M280.4,384.05l-.43.11c-2.3-5.17.35-8.26.26-9.95-.07-1.36-.7-2.67-1.85-3.4-1.7-1.07-3.41-.32-4.9.5-.03.02-.06.03-.08.05-4.49,2.45-8.28,6.01-10.89,10.41-2.43,4.1-5.38,9.66-6.86,14.7l26.1,7.82c.13-.89.26-1.8.38-2.71.45-3.36,1.15-6.69,2.04-9.97l.8-2.93c.76-2.78-1.77-5.34-4.56-4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M304.2,405.36c-.92.13-1.9.19-2.93.19-15.13-.04-29.74-5.88-43.51-11.58-10.22-4.23-24.01-10.68-31.29,2.19-4.28,7.56-1.62,17.16,5.94,21.44l1.23.7,1.12.62c18.65,10.13,39.63,17.68,61.04,18.13,4.99.12,9.86-.41,14.47-1.56.35-2.25.54-4.56.54-6.92,0-8.66-2.46-16.66-6.62-23.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M344.95,364.53c-.4-2.98-1.35-6.76-2.39-10.14-1.58-5.13-4.03-11.98-10.45-11.07-6.05.86-7.88,7.77-8.42,12.71l-.53-.08c-2.59-.41-3.81,1.5-4.02,3.96-.04.54.04,1.08.2,1.6l2.05,10.29c.78,2.57.91,5.3.4,7.94-.64,3.31-1.45,6.58-2.47,9.79-2.65,8.32-6.69,14.68-15.13,15.83,4.16,6.53,6.62,14.54,6.62,23.2,0,2.36-.19,4.67-.54,6.92,14.62-3.63,26.68-13.52,31.96-29.01,4.64-13.61,4.57-27.88,2.71-41.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "254.82 562.98 243.47 637.93 237.39 656.13 271.81 656.13 270.74 630.29 254.82 562.98"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "300.74 656.13 271.81 656.13 273.9 706.76 297.84 706.76 300.74 656.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "237.39 656.13 204.24 656.13 197.41 706.76 220.47 706.76 237.39 656.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M331.36,757.15v-1.41c0-.34-.07-.67-.19-.98h-55.29l.1,2.39h55.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M246.48,757.39v-1.41c0-.43-.11-.85-.29-1.22h-55.25l-.36,2.64h55.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M210.42,714.17l1.77,2.62s.93-3.63,6.31-4.15l1.96-5.87h-23.06l-.78,5.8h10.78c1.21,0,2.34.6,3.02,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M246.18,754.76c-.27-.54-.72-1-1.3-1.26l-19.44-9.69c-5.56-2.56-8.08-7.05-9.18-12.44-1.03-5.04-.59-10.26,1.04-15.13l1.2-3.6c-5.39.53-6.31,4.15-6.31,4.15l-1.77-2.62c-.68-1-1.81-1.6-3.02-1.6h-10.78l-5.7,42.19h55.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M288.63,712.56c1.21,0,2.34.6,3.02,1.6l1.77,2.62s.65-2.56,4.06-3.69l.36-6.33h-23.93l.24,5.8h14.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M331.18,754.76c-.25-.65-.74-1.2-1.4-1.5l-19.44-9.69c-.29-.14-.58-.28-.87-.42-8.2-4.18-12.97-12.99-12.44-22.18l.45-7.87c-3.4,1.13-4.06,3.69-4.06,3.69l-1.77-2.62c-.68-1-1.81-1.6-3.02-1.6h-14.48l1.75,42.19h55.29Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 206.13,
    cy: 737.62,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 288.41,
    cy: 737.62,
    r: 3.96
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M222.21,376.77c4.95-5.9,4.73-14.84,1.51-21.84-1.36-2.96-3.93-7.33-7.06-11.09,3.52-3,6.59-6.51,8.73-10.59,2.95-5.63,4.01-12.41,2.02-18.45-.84-2.55-2.18-4.9-3.66-7.13-1.96-2.97-4.39-5.94-7.81-6.9-1.95-.55-4.05-.38-6.01.14-6.03,1.61-10.83,6.49-13.52,12.12-.91,1.91-1.58,3.78-2.05,5.63-5.2-.55-10.79,2.66-13.21,8.53-1.78,4.3-1.34,9.41-3.78,13.37-2.62,4.26-7.86,6.13-11.24,9.82-5.97,6.51-4.23,17.89,2.53,23.58,2.43,2.04,5.31,3.39,8.37,4.11-1.37,5.25-1.93,10.61-1.14,16.03.54,3.7,1.79,7.43,4.36,10.13,3.05,3.21,7.53,4.58,11.86,5.5,7.79,1.65,16.35,2.13,23.3-1.77,6.94-3.9,11.1-13.47,6.87-20.22-1.27-2.03-3.27-3.97-3-6.35.21-1.85,1.74-3.21,2.94-4.64Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentsCompleted);
export default __webpack_public_path__ + "static/media/assessmentsCompleted.2f998d5deeed2c965412abb1dba180ab.svg";
export { ForwardRef as ReactComponent };